import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';

const getNextDay = (dateStr) => {
  if (!dateStr) return 'N/A';
  const [d, m, y] = dateStr.split('/');
  return new Date(y, m-1, +d+1).toLocaleDateString('en-GB');
};
        
const nonemployement = ({ result }) => {
  const nextDay = getNextDay(result?.dateOfRetirement);
    
    
    
    
    
    return(


              <View size="A4" style={style.page}> 
                <Text style={[style.subtitle, style.marathi]}>शासन परिपत्रक क्रमाांक : वेतन-१२२१/प्र.क्र.११९/टीएनटी-३</Text>
                <Text style={[style.subtitle, style.marathi]}>(शासन परिपत्रक शालेय शशक्षण व शिडा शवभाग, िमाांक.वेतन-१०२१/प्र.ि.११९/टीएनटी-३
शिनाांक २२.१२.२०२१ चे सहपत्र)</Text>

                 <Text style={[style.title, style.marathi]}>वचनपत्र</Text>
                
                <View style={style.solidLine} />
               
                <Text style={[style.paragraph,style.marathi, { marginTop: 20 }]}>
              मी {result.employeeNameMar} , {result.institutionNameMar} या शाळेत / स्थाननक स्विाज्य सांस्थेत, {result.designationMar} या पदावि काययित आहे/ होते .मला शासनाकडून कोणत्याही प्रसांगी जसे की, माझी सेवेत नव्याने ननयुक्ती होईल तेव्हा नकांवा अन्य प्रकािे वेतन नननिती / वेतनवाढी अथवा इति कोणत्याही आनथयक लाभाच्या / प्रदानाच्या अनुषांगाने माझ्या सांपूणय सेवा कालावधीत, 
                ननयमानुसाि अथवा कायद्यानुसाि देय व अनुज्ञेय ठित नसताना (Excess of Entitlements),
                अनतरिक्त िक्कम प्रदान झाल्याची बाब सद्य स्थस्थतीत / भनवष्यात शासनाच्या ननदशयनास आली 
                /आल्यास, याद्वािे मी असे वचनपत्र देतो की, परिगणनेतील त्रुटीमुळे अथवा कोणत्याही कािणास्तव सदि िकमेमध्ये काही 
                जादा िकमेचे प्रदान केल्याचे सद्य स्थस्थतीत / भनवष्यात शासनाच्या ननदशयनास आल्यास अशी अनतप्रदानाची िक्कम शासनास समायोजन 
                / िोख स्वरुपात पित किण्यास मी न चुकता बाांनधल आहे / िानहल.
                </Text>
                      
           
                   <Text style={[style.paragraph, style.marathi,{marginTop:10}]}>ठिकाण - {result.regionalPlaceMar}</Text>   
           

                <Text style={[style.signature,style.marathi, {marginTop: 40}]}>{result.employeeNameMar}</Text>
                <Text style={[style.signature, style.marathi, {marginTop: 80}]}>प्राचार्य</Text>

          
           </View>

);
};
export default nonemployement;